;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { i18n, Locale } from 'shared/i18n/i18n-config';

export default function splitLanguageFromPath(pathname: string): { locale: Locale; pathname: string } {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return { locale: 'nl', pathname: '/' };
  if (!i18n.locales.includes(parts[0] as Locale)) return { locale: 'nl', pathname: '/' + parts.join('/') };

  const [locale, ...rest] = parts;
  return { locale: locale as Locale, pathname: '/' + rest.join('/') };
}
